<template>
  <div
    id="app"
    class="flex h-screen overflow-hidden bg-gray-100">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
    <div
      v-if="isHidden"
      class="main-menu md:hidden">
      <div
        class="fixed inset-0 z-40 flex">
        <!--
                    Off-canvas menu overlay, show/hide based on off-canvas menu state.

                    Entering: "transition-opacity ease-linear duration-300"
                        From: "opacity-0"
                        To: "opacity-100"
                    Leaving: "transition-opacity ease-linear duration-300"
                        From: "opacity-100"
                        To: "opacity-0"
                -->
        <div
          class="fixed inset-0"
          aria-hidden="true">
          <div
            class="absolute inset-0 bg-gray-600 opacity-75" />
        </div>
        <!--
                    Off-canvas menu, show/hide based on off-canvas menu state.

                    Entering: "transition ease-in-out duration-300 transform"
                        From: "-translate-x-full"
                        To: "translate-x-0"
                    Leaving: "transition ease-in-out duration-300 transform"
                        From: "translate-x-0"
                        To: "-translate-x-full"
                -->
        <div
          class="relative flex w-full max-w-xs flex-1 flex-col bg-white pb-4 pt-5">
          <div
            class="absolute right-0 top-0 -mr-12 pt-2">
            <button
              class="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              @click="isHidden = !isHidden">
              <!-- Heroicon name: x -->
              <svg
                class="h-6 w-6 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div
            class="flex shrink-0 items-center px-4">
            <img
              class="h-5 w-auto"
              src="/img/traveloffice-logo.svg"
              alt="TravelOffice">
          </div>
          <div
            class="mt-5 h-0 flex-1 overflow-y-auto">
            <nav
              class="space-y-1 px-2">
              <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-100 hover:text-gray-900" -->
              <Link
                :href="route('dashboard')"
                class="group flex items-center rounded-md bg-gray-100 p-2 text-base font-medium text-gray-900 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-900 hover:underline focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                exact
                @click="isHidden = !isHidden">
                <!-- Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500" -->
                <!-- Heroicon name: home -->
                <svg
                  class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Dashboard
              </Link>

              <Link
                :href="route('clients')"
                class="group flex items-center rounded-md p-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-900 hover:underline focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                @click="isHidden = !isHidden">
                <!-- Heroicon name: users -->
                <svg
                  class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                Clients
              </Link>

              <Link
                :href="route('destinations')"
                class="group flex items-center rounded-md p-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-900 hover:underline focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                @click="isHidden = !isHidden">
                <!-- Heroicon name: globe -->
                <svg
                  class="mr-4 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Destinations
              </Link>

              <Link
                :href="route('projects')"
                class="group flex items-center rounded-md p-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-900 hover:underline focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                @click="isHidden = !isHidden">
                <!-- Heroicon name: folder-open -->
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z" />
                </svg>
                Projects
              </Link>

              <div
                class="relative py-1">
                <div
                  class="absolute inset-0 flex items-center"
                  aria-hidden="true">
                  <div
                    class="w-full border-t border-gray-300" />
                </div>
              </div>

              <Link
                :href="route('proposals.create')"
                class="group flex items-center rounded-md p-2 text-base font-medium leading-5 text-gray-600 transition duration-150 ease-in-out hover:bg-gray-100 hover:text-gray-900 hover:underline focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                @click="isHidden = !isHidden">
                <!-- Heroicon name: document-add -->
                <svg
                  class="mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Create
                new
                proposal
              </Link>
            </nav>
          </div>
        </div>
        <div
          class="w-14 shrink-0"
          aria-hidden="true">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Dynamic content frame -->
    <div
      id="main-content"
      class="flex w-0 flex-1 flex-col overflow-hidden">
      <!-- Header content frame -->
      <div class="z-5 relative flex h-16 shrink-0 bg-white shadow">
        <!-- Sidebar toggle, mobile -->
        <button
          class="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
          @click="isHidden = !isHidden">
          <span class="sr-only">Open sidebar</span>
          <Bars3BottomLeftIcon
            class="h-6 w-6"
            aria-hidden="true" />
        </button>

        <!-- Header content -->
        <div class="flex flex-1 justify-between px-4">
          <!-- Top bar -->
          <div class="flex flex-1 items-center space-x-4">
            <button
              class="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100
                px-4 py-1 text-gray-700 hover:border-gray-400 hover:bg-gray-200 hover:text-gray-800
                focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              title="Click to get to dashboard"
              @click="$inertia.get(route('dashboard'))">
              <HomeIcon
                class="h-5 w-5"
                aria-hidden="true" />
              <span class="ml-2">Dashboard</span>
            </button>
          </div>

          <!-- User information -->
          <div class="ml-4 flex items-center space-x-2 md:ml-6">
            <!-- Notification dropdown -->
            <button
              class="cursor-not-allowed rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
              <span class="sr-only">View notifications</span>
              <BellIcon
                class="h-6 w-6"
                aria-hidden="true" />
            </button>
            <!-- Profile dropdown -->
            <ProfileMenu
              :show="showProfileMenu"
              @update:show="showProfileMenu = $event" />
          </div>
        </div>
      </div>

      <!-- Main content -->
      <main
        class="relative flex-1 overflow-y-auto focus:outline-none"
        tabindex="0">
        <div class="p-6">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import ProfileMenu from '@/Components/ProfileMenu.vue';
import {
  Bars3BottomLeftIcon,
} from '@heroicons/vue/24/solid';
import {
  BellIcon, HomeIcon,
} from '@heroicons/vue/24/outline';

export default {
  components: {
    BellIcon,
    Bars3BottomLeftIcon,
    HomeIcon,
    ProfileMenu,
    Link,
  },

  data() {
    return {
      showingNavigationDropdown: false,
      isHidden: false,
    };
  },
};
</script>
